<script>
  import Page from 'page'
  import { api } from '../../store'
  let localapi
  api.subscribe((value) => {
    localapi = value
  })
  let loading = false
  JSON.parse(localStorage.getItem('loginData')) === null
    ? Page.redirect('/')
    : null
  let search, state
  let datum = false
  let USStates = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ]

  let count = false
  let olimit = 10
  let start = 0
  let limit = 10
  function searchQ() {
    loading = true
    if (state == '') {
      alert('Please select a state')
    } else {
      console.log('start: ' + start, 'limit: ' + limit)
      let data = new FormData()
      let loginDatum = JSON.parse(localStorage.getItem('loginData'))
      data.append('search', search)
      data.append('searchState', state)
      data.append('start', start)
      data.append('limit', olimit)

      let xhttp = new XMLHttpRequest()

      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          // Typical action to be performed when the document is ready:
          let result = JSON.parse(xhttp.responseText)
          console.log(result)
          if (result.data.error) {
            start = 0
            limit = olimit
            count = 0
            alert('There Is no results')
            datum = false
            loading = false
          } else {
            datum = result.data
            count = result.count
            loading = false
          }
        }
      }

      xhttp.open('POST', `${localapi}?url=search`, true)
      xhttp.setRequestHeader('Authorization', `Bearer ${loginDatum.token}`)
      xhttp.send(data)
    }
  }
</script>

{#if loading}
  <div class="loader-div">
    <span class="loader">
      <span></span>
      <span></span>
    </span>
  </div>
{/if}

<div class="minibar">
  <button
    on:click="{() => {
      Page.redirect('/members')
    }}"
    class="btn btn-success">Go Back</button>
  <button
    on:click="{() => {
      Page.redirect('/logout')
    }}"
    class="btn btn-danger">Logout</button>
</div>

<div class="search">
  <div class="display-count">
    {#if count != false}
      <p class="text-center">Total number of results <b>{count}</b></p>
    {/if}
  </div>
  <div class="bar">
    <input bind:value="{search}" placeholder="Search for city" type="text" />

    <select bind:value="{state}" class="form-select">
      {#each USStates as state}
        <option value="{state}">{state}</option>
      {/each}
    </select>
    <button
      class="btn btn-success"
      on:click="{() => {
        start = 0
        limit = olimit
        searchQ()
      }}">Search</button>
  </div>

  <div class="result">
    <table>
      {#if datum != false}
        {#each datum as data}
          <tr>
            <td>
              <span>Name: {data.firstName} {data.lastName}</span>
            </td>
            <td>
              <span>Mobile: {data.mobileNumber}</span>
            </td>
            <td>
              <span>city: {data.city}</span>
            </td>
            <td>
              <span>Address: {data.address}</span>
            </td>
          </tr>
        {/each}
      {/if}
    </table>
  </div>
  <div class="loadmore">
    {#if count != false && limit > olimit && count > olimit}
      <button
        class="btn btn-success"
        on:click="{() => {
          start = start - olimit
          limit = limit - olimit
          searchQ()
        }}">Previous</button>
    {/if}

    {#if count > olimit}
      {#if count != false && count > limit && count > olimit && count > limit}
        <button
          class="btn btn-success"
          on:click="{() => {
            start = start + olimit
            limit = limit + olimit
            searchQ()
          }}">Next</button>
      {/if}
    {/if}
  </div>
</div>

<style lang="scss">
  .loader-div {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(51, 51, 51, 0.274);
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader {
    position: relative;
    width: 10vw;
    height: 5vw;
    padding: 1.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader span {
    position: absolute;
    height: 0.8vw;
    width: 0.8vw;
    border-radius: 50%;
    background-color: #ff0;
  }

  .loader span:nth-child(1) {
    animation: loading-dotsA 0.5s infinite linear;
  }

  .loader span:nth-child(2) {
    animation: loading-dotsB 0.5s infinite linear;
  }

  @keyframes loading-dotsA {
    0% {
      transform: none;
    }
    25% {
      transform: translateX(2vw);
    }
    50% {
      transform: none;
    }
    75% {
      transform: translateY(2vw);
    }
    100% {
      transform: none;
    }
  }

  @keyframes loading-dotsB {
    0% {
      transform: none;
    }
    25% {
      transform: translateX(-2vw);
    }
    50% {
      transform: none;
    }
    75% {
      transform: translateY(-2vw);
    }
    100% {
      transform: none;
    }
  }

  .loadmore {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      margin: auto 10px;
      min-width: 100px;
    }
  }
  .result {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    table {
      width: 100%;
      max-width: 1050px;
      tr {
        @media only screen and (max-width: 1000px) {
          display: flex;
          justify-content: center;
          align-items: start;
          flex-direction: column;
        }

        &:nth-child(even) {
          background-color: rgb(255, 236, 159);
        }
        background-color: beige;
        border: 1px #000 solid;
        margin-bottom: 10px;

        td {
          padding: 5px;
        }
      }
    }
  }
  .search {
    width: 90vw;
    margin: auto;
    min-height: 150px;

    .bar {
      height: 10vh;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      select,
      input {
        all: none;
        height: 40px;
        padding: 0;
        margin: 0 5px;
        border: none;
      }
      select {
        max-width: 250px;
        border: 1px #ff9933 dotted;
        padding: 5px;
      }
      input {
        width: 100%;
        max-width: 380px;
        border-bottom: 3px #000 solid;
        transition: all 0.2s ease-in-out;

        &:active,
        &:focus {
          outline-style: none;
          border: none;
          border-bottom: 3px #ff9933 solid;
        }
      }
    }
  }

  .minibar {
    width: 100vw;
    min-height: 10vh;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    button {
      min-width: 150px;
      margin: 10px 5px;
    }
  }
</style>
